import styled from '@emotion/styled';
import { colorToAlpha } from 'helpers/insight';

export const InfoRow = styled.div<{ forceInline?: boolean, agentConsole?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  ${({ theme, agentConsole }) => agentConsole ? `padding-right: ${theme.spacing(1)};` : ''}

  & + div {
    margin-top: ${({ theme }) => theme.spacing(2)};
  }

  > div {
    ${({ agentConsole }) => agentConsole ? '' : 'flex-basis: 50%;'}

    ${props => !props.forceInline ? props.theme.media.showAt({ at: 1 })`
      flex-basis: 100%;
    ` : ''}
  }
`;

export const SeparatorWrapper = styled.span`
  margin: -${({ theme }) => `0 ${theme.spacing(1)}`};
`;

export const TableWrapper = styled.div<{ isCompare?: boolean }>`
  ${({ theme }) => theme.isRTL ? theme.media.showAt({ at: 1 })`
    .tbody .table-row {
      min-height: 96px;
    }
  ` : ''}

 ${({ theme, isCompare }) => isCompare ? `
    .table-row:hover {
      a > div {
        color: ${theme.colors.brand.main};
      }
    }
 ` : null}
`;

export const ThisUnitLabel = styled.div`
  ${({ theme }) => `
    color: ${theme.colors.brand.main};
    background-color: ${colorToAlpha(theme.colors.brand.main, 0.07)};
    border-radius: ${theme.borderRadius.tiny};
    padding: ${theme.spacing(0.25)} ${theme.spacing(0.5)};
  `}
`;

export const ThisUnitLabelHistory = styled(ThisUnitLabel)`
  display: initial;
  font-size: 13px;
`;
